import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchJobs } from "../features/jobs/jobSlice";
export default function Dashboard() {
  const dispatch = useDispatch();
  const { jobs } = useSelector((state) => state.job);
  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

    const stats = {
    pending: 0,
    rejected: 0,
    interview: 0,
  };

  jobs.forEach((job) => {
    if (job.status === "pending") stats.pending++;
    if (job.status === "rejected") stats.rejected++;
    if (job.status === "interview") stats.interview++;
  });
  

  return (
    <div className="container mt-4">
    <div className="container">
      <div className="row g-3">
        <div className=" col-md-3">
          <div className="card text-center">
            <div className="card-body">
              <h6>Total Applications</h6>
              <h2>{jobs.length}</h2>
            </div>
          </div>
        </div>

        <div className=" col-md-3">
          <div className="card text-center">
            <div className="card-body">
              <h6>Pending Applications</h6>
              <h2>{stats.pending}</h2>
              {/* <h2>{jobs.filter(j => j.status === 'pending').length}</h2> */}
            </div>
          </div>
        </div>

        <div className=" col-md-3">
          <div className="card text-center">
            <div className="card-body">
              <h6>Rejected Applications</h6>
              <h2>{stats.rejected}</h2>
              {/* <h2>{jobs.filter(j => j.status === 'rejected').length}</h2> */}
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-center">
            <div className="card-body">
              <h6>Awaiting an interview</h6>
              <h2>{stats.interview}</h2>
              {/* <h2>{jobs.filter(j => j.status === 'interview').length}</h2> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /> <br></br>
     <h5>Recent Activity</h5>
     {jobs.length > 0 ? (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Company</th>
            <th>Position</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
            {jobs.map((job) => (
              <tr key={job.id}>
                <td>{job.company}</td>
                <td>{job.position}</td>
                <td>{job.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="h8"> No Recent Activity</p>
      )}

  </div>
  );
}

//TODO  en son eklenenler en uste gelecek sekilde olmali 